import React, { useState} from 'react';
import { useLocation } from 'react-router-dom';
import Navigation from '../Navigation/Navigation';
import '../Header/Header.css';
// import Notes from ...


function Header ({
  isLoggedIn,
  onSignInPopupClick,
  onMobilePopupClick,
  onMobilePopupMenu,
  onSignOutPopupClick,
  onMobileSignoutClick,
  onMobileSignoutMenu
  })
  {

    //const location = useLocation();
    // isLoggedin  ile farkli header
    // const isSavedNotes = location.pathname === '/notes';
  
    return (
      <header className="header">
        <div className="header-row1"> </div>
        { isLoggedIn  // && isNSavedNotes
        ? 
        ( <section className="header__logged-in">
            <Navigation 
              isLoggedIn={isLoggedIn}
              onMobileMenu={onMobilePopupMenu}
              onSignOut={onSignOutPopupClick}
              onMobileSignout={onMobileSignoutClick}
            />
          </section> ) 
        :
        (
          <section className="header__nologin">
            <Navigation 
              onDesktopClick={onSignInPopupClick}
              onMobileClick={onMobilePopupClick}    
            />
          </section>
        )
        }
          

      </header>
      )
  }
  



export default Header